import React from 'react';
import HelloSign from 'hellosign-embedded';
import Axios from '../request';
import { Flex, Text } from '../components';
import { skipDomainVerificationHelloSign, helloSignClientId } from '../../../config';
import { isActionAssigneeMatchCompanyStaffV2 } from '../../../utils';
import { PageTitle } from '../biz-components/page-title';

class SignDocumentAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      signError: undefined,
    };
    this.isOnboardingV2 = isOnboardingV2 === 'true';
  }

  isViewAsAssignee() {
    const { action: { assignees }, companyStaff } = this.props;
    return isActionAssigneeMatchCompanyStaffV2(assignees, companyStaff);
  }

  shouldRenderHS() {
    // Always render in preview mode
    if (this.props.previewMode) return true;
    // Always render when opened by an employee
    const viewAsEmployee = this.props.companyStaff.id === undefined;
    if (viewAsEmployee) return true;
    // Render when assginees match the viewer
    if (this.isViewAsAssignee()) return true;
    return false;
  }

  componentDidMount() {
    if (this.shouldRenderHS()) {
      const { signLink, action, message } = this.props;

      if (!message) {
        const containerId = 'iframe-container';
        this.hellosignClient = new HelloSign({
          clientId: helloSignClientId,
        });
        this.hellosignClient.once(HelloSign.events.SIGN, (eventData) => {
          const { event } = eventData;
          if (event === HelloSign.EVENT_SIGNED) {
            let apiURL;
            if (action.action_type === 'employee_sign_company_document') {
              apiURL = `${APIHOST}/v1/onboarding/employee/employee_onboarding_actions/${action.digest_key}/employee_offer_signers/${eventData.signatureId}`;
            } else if (action.action_type === 'hr_sign_company_document') {
              apiURL = `${APIHOST}/v1/onboarding/hr/employee_onboarding_actions/${action.digest_key}/employee_offer_signers/${eventData.signatureId}`;
            }

            const config = {
              method: 'PUT',
              url: apiURL,
              data: {
                employee_offer_signer: { status: 'signed' },
              },
            };
            Axios(config)
              .then(() => {
                this.props.onSignedSuccess();
              })
              .catch((error) => {
                let signError = 'Something wrong with the signing.';
                if (error && error.response && error.response.data) {
                  const { error_code: errorCode, message } = error.response.data;
                  if (message) {
                    signError = message;
                  }
                  if (errorCode === 43001 || errorCode === 43002) {
                    // Need to refresh the side bar action status
                    if (this.props.refreshProgressDataFn) this.props.refreshProgressDataFn();
                  }
                }
                this.setState({ signError });
              });
          } else if (this.props.refreshProgressDataFn) this.props.refreshProgressDataFn();
        });

        const options = {
          skipDomainVerification: skipDomainVerificationHelloSign,
          container: document.getElementById(containerId),
        };

        this.hellosignClient.open(signLink, options);
      }
    }
  }

  componentWillUnmount() {
    this.hellosignClient && this.hellosignClient.close();
  }

  assigneeLabel() {
    const { action: { assignees }, offer, previewMode } = this.props;
    let assigneeName;

    if (offer && previewMode) {
      assigneeName = offer.preview_link.name;
    } else if (assignees && assignees[0]) {
      const assignee = assignees[0].employee || assignees[0].company_staff;
      assigneeName = assignee.name;
    } else {
      assigneeName = null;
    }

    if (assigneeName) {
      return `This step should be completed by ${assigneeName}`;
    }

    return 'There are no assignees available to complete this step';
  }

  render() {
    const { signError } = this.state;
    const { title, message } = this.props;

    return (
      <Flex column>
        {
          this.isOnboardingV2 && <PageTitle title={this.props.action.module_name} />
        }
        <Flex column>
          <Flex mb={20}>
            <Text fontSize="22px" bold>{title}</Text>
          </Flex>
          {
            this.shouldRenderHS() ? message || <div id="iframe-container" style={{ height: '640px' }} />
              : this.assigneeLabel()
          }
          {signError && <Text color="red">{signError}</Text>}
        </Flex>
      </Flex>
    );
  }
}

export default SignDocumentAction;
